/** Request routes. */
import { RequestsListPage } from "./RequestList.js";
import { NewRequestPage } from "./NewRequest.js";
import { RequestDetailPage } from "./RequestDetail.js";

export const requestsRoutes = [
  { path: "requests", element: <RequestsListPage /> },
  { path: "requests/new", element: <NewRequestPage /> },
  { path: "requests/:id", element: <RequestDetailPage /> },
];
